import { configureStore, createListenerMiddleware } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import { awsApi, baseApi, productInformationApi } from 'services/api/base';
import { environmentManager } from 'services/api/config';
import reducer from './rootReducer';
import sagas from './rootSaga';
import { queryErrorLogger } from './middlewares';
import { SortType } from './tags';
import type { DownloadLimit } from './user';
import { DownloadLimitStatus } from './user';

export type AppDispatch = typeof store.dispatch;

const listenerMiddleware = createListenerMiddleware();

const sagaMiddleware = createSagaMiddleware();
const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
    })
      .prepend(listenerMiddleware.middleware)
      .concat(sagaMiddleware)
      .concat(baseApi.middleware)
      .concat(awsApi.middleware)
      .concat(productInformationApi.middleware)
      .concat(queryErrorLogger),
  devTools: !environmentManager.isProductionEnv,
});
sagaMiddleware.run(sagas);

export type { DownloadLimit };
export type RootState = ReturnType<typeof store.getState>;
export { DownloadLimitStatus, SortType };
export default store;
